module.exports = __webpack_public_path__ + "static/008477-76c6298c7de15f191dea9cf90ad2fae5.jpg";